import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {finalize, map} from 'rxjs/operators';

import {BBS_API_URL} from '../../defines/protocol';
import {SearchParam} from '../../defines/client.const';
import {Article} from '../../models/article.model';
import {ApiService} from '../api/api.service';
import {NormalizeSearchKeyword} from '../../defines/search-keyword.func';


@Injectable({
  providedIn: 'root'
})
export class BoardService {

  private load$ = new Observable<Array<Article>>();
  private loadDetail$ = new Observable<Article>();

  public get IsLoading(): boolean {
    return this.load$ !== null;
  }


  constructor(
    private api: ApiService,
  ) { }


  public GetList(param: SearchParam = null): Observable<Array<Article>>
  {
    let url = null;

    if (param) {
      if ('bbs_cat' in param) {
        url = BBS_API_URL + '?cat=' + param.bbs_cat;
      }

      if ('keyword' in param) {
        const keyword = NormalizeSearchKeyword(param.keyword);
        if (keyword) {
          url = url ?
            url + '&search=' + keyword :
            BBS_API_URL + '?search=' + keyword;
        }
      }
    }
    if (!url) {
      url = BBS_API_URL;
    }
    console.log('BoardService::GetList() url =', url);

    return this.load$ = this.api.Get(url).pipe(
      map((data: []) => {
        const result = new Array<Article>();
        data.forEach(article => result.push(new Article(article)));
        console.log('BoardService::GetList() data=', data, result);
        return result;
      }),
      finalize(() => this.load$ = null)
    );
  }


  public GetDetail(no: number): Observable<Article>
  {
    const url = BBS_API_URL + no + '/';
    console.log('BoardService::GetDetail() url =', url);

    return this.loadDetail$ = this.api.Get(url).pipe(
      map(data => {
        return data;
      }),
      finalize(() => this.loadDetail$ = null)
    );
  }
}
